module.exports = __webpack_public_path__ + "img/logos.7424376e.svg";